import { render, staticRenderFns } from "./categ_settings.vue?vue&type=template&id=7035b70c&scoped=true&"
import script from "./categ_settings.vue?vue&type=script&lang=js&"
export * from "./categ_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035b70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7035b70c')) {
      api.createRecord('7035b70c', component.options)
    } else {
      api.reload('7035b70c', component.options)
    }
    module.hot.accept("./categ_settings.vue?vue&type=template&id=7035b70c&scoped=true&", function () {
      api.rerender('7035b70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_settings.vue"
export default component.exports